export const CUSTOMERS_FEATURE_KEY = 'customers';
